import type { IEquipmentServiceClient } from '~/services/interfaces/IEquipmentServiceClient';
import type { ICatalogPanelPage, ICatalogPanelQuery } from '~/types/equipment';

/** The equipment service's catalog, as quote-edit's EquipmentServiceClient reads it. Its panel search needs no sign-in. */
export class EquipmentServiceClient implements IEquipmentServiceClient {
    readonly standIn = false;
    private readonly domain: string;
    private equipmentFetch: ReturnType<typeof $fetch.create>;

    constructor() {
        this.domain = useRuntimeConfig().public.EQUIPMENT_SERVICE_DOMAIN;
        this.equipmentFetch = $fetch.create({ baseURL: `${this.domain}/api/v1` });
    }

    async listPanels({ search, page = 1, size = 12 }: ICatalogPanelQuery): Promise<ICatalogPanelPage> {
        const params = new URLSearchParams({ page: String(page), size: String(size) });
        if (search) params.set('search', search);
        try {
            return await this.equipmentFetch<ICatalogPanelPage>(`/equipment/solar-panels?${params}`);
        } catch (error) {
            const { status } = error as { status?: number };
            throw new Error(
                status
                    ? `the equipment service answered ${status}.`
                    : `can't reach the equipment service at ${this.domain}.`,
                { cause: error },
            );
        }
    }
}
